import './_image-quote-section.scss';